<table class="utilization-in-period-table" width="100%">
    <thead>
    <tr class="c-text--dark-gray c-text--sm">
        <th scope="col">{{'Hr_Dashboard.Table_Hr_Invitations.Activity' | translate}}</th>
        <th scope="col" style="text-align: center;">{{'Hr_Dashboard.Table_Hr_Invitations.Count' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
        <td colspan="5" class="divider">
            <hr />
        </td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{'Hr_Dashboard.Table_Hr_Invitations.Invitations_Sent_To_Employees' | translate}}</th>
        <td>{{vm.generatedPreview ? vm.generatedPreview.invitationsCount || 0 : 0}}</td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{'Hr_Dashboard.Table_Hr_Invitations.Total_Registered_Active_Users' | translate}}</th>
        <td>{{vm.generatedPreview ? vm.generatedPreview.activeUsersCount || 0 : 0}}</td>
    </tr>
    <tr class="c-text--sm">
        <th scope="row">{{'Hr_Dashboard.Table_Hr_Invitations.Total_Number_Of_Not_Accepted' | translate}}</th>
        <td>{{vm.generatedPreview ? vm.generatedPreview.pendingInvitationsCount || 0 : 0}}</td>
    </tr>
    </tbody>
</table>
